module.exports = __webpack_public_path__ + "img/ruler-vertical.5178da0e.svg";